import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import classnames from 'classnames';
import { DropTarget } from 'react-dnd';
import { NavLink } from 'reactstrap';

import { isArchive } from '../../helpers/App';
import { collectionsTarget } from '../../helpers/DNDCollections';
import ItemTypes from '../../helpers/DNDItemTypes';

const SidebarCollection = ({
  connectDropTarget,
  collection,
  isOver,
  canDrop,
  onClick,
}) => connectDropTarget((
  <div
    className={classnames(
      'nav-item',
      {
        hovered: isOver && canDrop,
      },
    )}
  >
    <NavLink tag={Link} to={`${isArchive() ? '/archive' : ''}/collections/${collection.uuid}`} onClick={onClick}>
      <i className="far fa-layer-group" />
      {collection.name}
    </NavLink>
  </div>
));

SidebarCollection.propTypes = {
  connectDropTarget: PropTypes.func.isRequired,
  collection: PropTypes.object.isRequired,
  isOver: PropTypes.bool.isRequired,
  canDrop: PropTypes.bool.isRequired,
  onClick: PropTypes.func,
};

export default (DropTarget([
  ItemTypes.COLLECTION,
  ItemTypes.FILE,
], collectionsTarget, (DNDconnect, monitor) => ({
  connectDropTarget: DNDconnect.dropTarget(),
  isOver: monitor.isOver(),
  canDrop: monitor.canDrop(),
}))(SidebarCollection));
